import commons from '../../util/commons';

export default {
  localUser: commons.readTodos('localUser'),
  localCart: commons.readTodos('localCart'),
  // 首页数据
  homedata: {}
};



// WEBPACK FOOTER //
// ./src/store/asset/state.js